import React, { useMemo } from 'react';
import { getCurrentProjectId } from '../../../../channels/chat/components/sharedChatService';
import { useVishCoderChat } from '../../../../channels/chat/components/useVishCoderChat';
import DiscoveryDocumentsShell from './DiscoveryDocumentsShell';

interface DiscoveryDocumentsFromChatProps {
    projectName: string;
    projectId: number | string;
}

/**
 * Live discovery document driven by the same discovery chat session as the right-hand panel.
 */
const DiscoveryDocumentsFromChat: React.FC<DiscoveryDocumentsFromChatProps> = ({ projectName, projectId }) => {
    const { chatMessages } = useVishCoderChat('project_chat', projectId, 'discovery');
    const scopedChatMessages = useMemo(() => {
        const activeProjectId = getCurrentProjectId();
        if (activeProjectId == null || String(activeProjectId) !== String(projectId)) {
            return [];
        }
        return chatMessages;
    }, [chatMessages, projectId]);

    return (
        <DiscoveryDocumentsShell
            projectName={projectName}
            projectId={projectId}
            chatMessages={scopedChatMessages}
        />
    );
};

export default DiscoveryDocumentsFromChat;
